import axios, { AxiosInstance } from 'axios'
import qs from 'qs'

export interface AddressProposition {
  type: string
  geometry: {
    type: string
    coordinates: number[]
  }
  properties: {
    label: string
    score: number
    housenumber?: string
    id: string
    name: string
    postcode: string
    citycode: string
    x: number
    y: number
    city: string
    oldcity?: string
    context: string
    type: string
    importance: number
    street: string
  }
}

export interface AddressApiResponse {
  type: string
  version: string
  features: AddressProposition[]
  attribution: string
  licence: string
  query: string
  limit: number
}

class AddressApi {
  private axios: AxiosInstance

  public constructor() {
    this.axios = axios.create({
      // baseURL: process.env.ADDRESS_GOUV_URL,
      baseURL: 'https://api-adresse.data.gouv.fr/search',
      headers: {
        'Content-Type': 'application/json',
      },
      paramsSerializer: {
        serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    })
  }

  public async findAddress(q: string, postcode: string, limit = 5): Promise<AddressApiResponse> {
    const p = postcode && postcode.length === 5 ? { q, postcode, limit } : { q, limit }
    const a = (await this.axios.get('/', { params: p })).data
    if (a.features?.length) {
      a.features.forEach((addr: AddressProposition) => {
        if (addr.properties?.city) {
          // eslint-disable-next-line no-param-reassign
          addr.properties.city = addr.properties.city.toLocaleUpperCase()
        }
      })
    }
    return a
  }
}

export const addressApi = new AddressApi()
